import {
  Directive,
  Input,
  OnInit,
  OnDestroy,
  ElementRef,
  Renderer2,
  HostListener,
} from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { takeUntil, startWith } from "rxjs/operators";

@Directive({
  selector: "[appPendingApprovalTooltip]",
  providers: [NgbTooltip],
})
export class PendingApprovalTooltipDirective implements OnInit, OnDestroy {
  @Input("appPendingApprovalTooltip") control: AbstractControl;
  @Input() pendingValue: any;
  @Input() initialValue: any;

  // This flag tracks if the tooltip should stay open regardless of hover state.
  //   private isPermanentlyOpen = false;
  private destroy$ = new Subject<void>();

  constructor(
    private tooltip: NgbTooltip,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  // --- NEW: Listen for mouse entering the element ---
  @HostListener("mouseenter")
  onMouseEnter() {
    // Show the tooltip on hover, but only if there's a message to show.
    if (
      this.control.dirty &&
      this.pendingValue !== null &&
      this.pendingValue !== undefined
    ) {
      this.tooltip.open();
    }
  }

  // --- NEW: Listen for mouse leaving the element ---
  @HostListener("mouseleave")
  onMouseLeave() {
    // Only close the tooltip if it's not being held open by the dirty state.
    // if (!this.isPermanentlyOpen) {
    this.tooltip.close();
    // }
  }

  ngOnInit(): void {
    if (!this.control) {
      console.error(
        "PendingApprovalTooltipDirective requires a form control instance."
      );
      return;
    }
    this.configureTooltip();

    this.control.statusChanges
      .pipe(startWith(this.control.status), takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateTooltipState();
      });
  }

  private configureTooltip(): void {
    this.tooltip.container = "body";
    this.tooltip.triggers = "manual"; // Keep this as manual
    this.tooltip.tooltipClass = "tooltip-danger";
    this.tooltip.placement = "top-left";
    this.renderer.setStyle(this.elementRef.nativeElement, "display", "none");
  }

  toComparableString(value: any): string {
    // For objects (but not null), use JSON.stringify
    if (typeof value === "object" && value !== null) {
      return JSON.stringify(value);
    }
    // For all primitives (string, number, boolean, null, undefined), use String()
    return String(value);
  }
  private updateTooltipState(): void {
    
    const hasPendingValue =
      this.pendingValue !== null && this.pendingValue !== undefined;
    let isValueSame =
      this.toComparableString(this.control.value) ==
      this.toComparableString(this.initialValue);

    console.log(
      isValueSame,
      this.toComparableString(this.control.value),
      this.toComparableString(this.initialValue)
    );

    const isVisible = this.control.dirty && hasPendingValue && !isValueSame;
    console.log("is visible==>", this.control.dirty, hasPendingValue);

    if (isVisible) {
      let spliceString = (str, maxLength) => {
        if (str.length <= maxLength) {
          return str; // No need to cut
        }
        return str.slice(0, maxLength) + "..."; // Cut and add dots
      };
      const message = `This field cannot be saved until the previous change is approved.\nPending value: ${spliceString(
        this.pendingValue,
        50
      )}`;
      //    const message = `This field cannot be saved until the previous change is approved.`;
      this.tooltip.ngbTooltip = message;
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        "display",
        "inline-block"
      );

      // Open the tooltip and set the flag to 'lock' it open.
      this.tooltip.open();
      //   this.isPermanentlyOpen = true;
    } else {
      // Hide the icon, close the tooltip, and 'unlock' it.
      this.renderer.setStyle(this.elementRef.nativeElement, "display", "none");
      this.tooltip.close();
      //   this.isPermanentlyOpen = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
